export class UtilsHelper {
  static nameSensor(type: number | string): { name: string; icon: string } {
    switch (type) {
      case 13: return { name: 'ATMOS22', icon: 'layers' };
      case 14: return { name: 'TEROS21', icon: 'speed' };
      case 15: return { name: 'BGTPH1', icon: 'layers' };
      case 16: return { name: 'ACCLIMA TDR315H', icon: 'layers' };
      case 17: return { name: 'CS320', icon: 'local_florist' };
      case 18: return { name: 'S2441SS', icon: 'local_florist' };
      case 19: return { name: 'S2422SS', icon: 'local_florist' };
      case 20: return { name: 'GERBIL XP02', icon: 'layers' };
      case 21: return { name: 'GERBIL XP03', icon: 'layers' };
      case 22: return { name: 'GERBIL XP04', icon: 'layers' };
      case 23: return { name: 'GERBIL XP06', icon: 'layers' };
      case 24: return { name: 'GERBIL XP08', icon: 'layers' };
      case 25: return { name: 'IG31', icon: 'layers' };
      case 26: return { name: 'MET3', icon: 'thermostat' };
      case 27: return { name: 'IG90 PULSOS', icon: 'cloud_queue' };
      case 28: return { name: 'TEROS12', icon: 'layers' };
      case 29: return { name: 'ES2', icon: 'local_florist' };
      case 30: return { name: 'AT32', icon: 'layers' };
      case 31: return { name: 'HYDROS21', icon: 'local_florist' };
      case 32: return { name: 'SP522SS', icon: 'local_florist' };
      case 33: return { name: 'BGTTBQ', icon: 'local_florist' };
      case 34: return { name: 'CO2SENSOR', icon: 'local_florist' };
      case 35: return { name: 'BGTWECK', icon: 'local_florist' };
      case 36: return { name: 'BGTWPHK', icon: 'local_florist' };
      case 37: return { name: 'TD50', icon: 'speed' };
      case 38: return { name: 'TD100', icon: 'speed' };
      case 39: return { name: 'TD420', icon: 'local_florist' };
      case 40: return { name: 'CWTSWDC360A_05', icon: 'local_florist' };
      case 41: return { name: 'CWTSWDC360A_010', icon: 'local_florist' };
      case 42: return { name: 'CWTSWDC360A_420', icon: 'local_florist' };
      case 43: return { name: 'IG90 CONTADOR DE PULSOS', icon: 'gas_meter' };
      case 44: return { name: 'H2 - HUMECTACIÓN DE HOJA', icon: 'layers' };
      case 45: return { name: 'PIRANÓMETRO', icon: 'layers' };
      case 46: return { name: 'CHINAWINDDIR_010', icon: 'layers' };
      case 47: return { name: 'CHINAWINDSPEED_010', icon: 'layers' };
      case 48: return { name: 'WNK8010TT20S1C130D4', icon: 'layers' };
      case 49: return { name: 'GENÉRICA_02', icon: 'layers' };
      case 50: return { name: 'GENÉRICA_05', icon: 'layers' };
      case 51: return { name: 'GENÉRICA_010', icon: 'layers' };
      case 52: return { name: 'GENÉRICA_420', icon: 'layers' };
      case 53: return { name: 'ATMOS41', icon: 'layers' };
      case 54: return { name: 'PUERTO VACÍO', icon: '' };
      case 55: return { name: 'PUERTO VACÍO', icon: '' };
      case 56: return { name: 'PUERTO VACÍO', icon: '' };
      case 57: return { name: 'PUERTO VACÍO', icon: '' };
      case 58: return { name: 'PUERTO VACÍO', icon: '' };


      default: return { name: `Sensor ${type}`, icon: 'help_outline' };
    }



  }


  static nameModule(type: number | string): string {
    switch (type) {
      case '0': return 'SDI12';
      case '1': return 'DDI';
      case '2': return 'RS232';
      case '3': return 'RS485';
      case '4': return 'ANALÓGICO';

      default:
        return `Module ${type}`;
    }
  }


  static readonly sensorsByModule: Record<number, number[]> = {
    0: [ // SDI12
      13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 28, 29, 53, 54
    ],
    1: [ // DDI
      25, 26, 27, 28, 14, 29, 30, 31, 44, 55
    ],
    2: [ // RS232
      32, 33, 56
    ],
    3: [ // RS485
      34, 35, 36, 30, 44, 57
    ],
    4: [ // ANALOGICO
      37, 38, 39, 40, 41, 42, 45, 46, 47, 48, 49, 50, 51, 52, 58
    ],
  };



  static getAvailableSensorsByModule(module: number | string): Array<{ id: number; name: string; icon: string }> {
    const m = Number(module);
    const ids = this.sensorsByModule[m] ?? [];
    return ids.map(id => ({ id, ...this.nameSensor(id) }));
  }
}
